export class Strings {
  static textOverflow(text: string | undefined, overflowCount: number) {
    if (text && text.length > overflowCount) {
      return text.substring(0, overflowCount) + ' ...';
    }
    return text;
  }
}
